import { createSvgIcon } from '@mui/material/utils';
import { createElement } from 'react';
// lucide's stroke icons, drawn with MUI's SvgIcon so the theme can hand them to Select and
// Autocomplete without a dependency on lucide-react.
const strokeGroup = (...children) => createElement('g', {
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
}, ...children);
/** lucide `chevron-down`: the one trailing glyph of every v2 dropdown trigger. */
export const V2ChevronDownIcon = createSvgIcon(strokeGroup(createElement('path', { d: 'm6 9 6 6 6-6' })), 'V2ChevronDown');
/** lucide `circle-x`: the clear glyph of every v2 dropdown trigger. */
export const V2CircleXIcon = createSvgIcon(strokeGroup(createElement('circle', { cx: 12, cy: 12, r: 10 }), createElement('path', { d: 'm15 9-6 6' }), createElement('path', { d: 'm9 9 6 6' })), 'V2CircleX');
